import { createFileRoute } from "@tanstack/react-router";
import { AuthLayout } from "../components/layout";
import { requireGuest } from "../utils/routeGuards";

export const Route = createFileRoute("/auth")({
  beforeLoad: ({ location }) =>
    requireGuest({
      allowedRoutes: [
        "/auth/verify-otp",
        "/auth/verify-method",
        "/auth/edit-number",
        "/auth/edit-email",
        "/auth/email-verification",
        "/auth/accept-legal",
      ],
      pathname: location.pathname,
    }),
  component: AuthLayout,
});
